import { render, staticRenderFns } from "./RulebookVersionsTab.vue?vue&type=template&id=4bf998ff&scoped=true&"
import script from "./RulebookVersionsTab.vue?vue&type=script&lang=js&"
export * from "./RulebookVersionsTab.vue?vue&type=script&lang=js&"
import style0 from "./RulebookVersionsTab.vue?vue&type=style&index=0&id=4bf998ff&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4bf998ff",
  null
  
)

export default component.exports